import { render, staticRenderFns } from "./InvestorRelations.vue?vue&type=template&id=278bb572&scoped=true&"
import script from "./InvestorRelations.vue?vue&type=script&lang=js&"
export * from "./InvestorRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bb572",
  null
  
)

export default component.exports